import {combineReducers} from 'redux';
import addReportReducers from './add-report/reducers';
import addressReducers from './addresses/reducers';
import attachmentsReducers from './attachments/reducers';
import commonReducers from '../../shared/store/common/reducers';
import dashboardReducers from './dashboard/reducers';
import departmentReducers from './department/reducers';
import departmentSettingsReducers from './department-settings/reducers';
import formsReducers from './forms/reducers';
import ftosReducers from './ftos/reducers';
import myDepartmentReducers from './my-department/reducers';
import myProfileReducers from './my-profile/reducers';
import myTrainingProgramReducers from './my-training-program/reducers';
import notesRuducers from './notes/reducers';
import notificationReducers from './notifications/reducers';
import oitsReducers from './oits/reducers';
import optionsReducers from './options/reducers';
import phoneReducers from './phones/reducers';
import publicReducers from './public/reducers';
import reportsReducers from './reports/reducers';
import tagReducers from './tags/reducers';
import taskReducers from './tasks/reducers';
import taskGroupReducers from './task-groups/reducers';
import tPsReducers from './training-programs/reducers';
import trainingPhasesReducers from './training-phases/reducers';
import usersReducers from './users/reducers';
import riskAlertsReducers from "./risk-alerts/reducers";
import taskTrainingReducers from "./task-training/reducers";
import subDepartmentsReducers from "./sub-departments/reducers";
import testTemplatesReducers from "./test-templates/reducers";
import testReducers from "./tests/reducers";
import calendarReducers from "./calendar/reducers";

const rootReducers = combineReducers({
  addReport: addReportReducers,
  addresses: addressReducers,
  attachments: attachmentsReducers,
  common: commonReducers,
  dashboard: dashboardReducers,
  department: departmentReducers,
  departmentSettings: departmentSettingsReducers,
  forms: formsReducers,
  ftos: ftosReducers,
  myDepartment: myDepartmentReducers,
  myProfile: myProfileReducers,
  myTrainingProgram: myTrainingProgramReducers,
  notes: notesRuducers,
  notifications: notificationReducers,
  oits: oitsReducers,
  options: optionsReducers,
  phones: phoneReducers,
  public: publicReducers,
  reports: reportsReducers,
  riskAlerts: riskAlertsReducers,
  tags: tagReducers,
  taskGroups: taskGroupReducers,
  tasks: taskReducers,
  testTemplates: testTemplatesReducers,
  tests: testReducers,
  trainingPrograms: tPsReducers,
  trainingPhases: trainingPhasesReducers,
  users: usersReducers,
  taskTraining: taskTrainingReducers,
  subDepartments: subDepartmentsReducers,
  calendar: calendarReducers
});

export default rootReducers;
